import { render, staticRenderFns } from "./SendComment.vue?vue&type=template&id=fe07b3e8&scoped=true&"
import script from "./SendComment.vue?vue&type=script&lang=js&"
export * from "./SendComment.vue?vue&type=script&lang=js&"
import style0 from "./SendComment.vue?vue&type=style&index=0&id=fe07b3e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe07b3e8",
  null
  
)

export default component.exports